import { Text } from '@mantine/core';

interface IInputLabel {
  label: string;
}

const InputLabel = ({ label }: IInputLabel) => {
  return (
    <Text size={'sm'} mb={8} c={'#323343'}>{label}</Text>
  )
}

export default InputLabel;